import Breadcrumbs from '@Components/Breadcrumbs';
import Heading from '@Components/Heading';
import { AssetTagList } from '@Components/AssetTags';

export default function AssetTags() {
  return (
    <div>
      <Breadcrumbs
        navList={[
          { name: 'Admin', href: '/' },
          { name: 'Asset Tags', href: '/asset-tags' },
        ]}
      />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Asset Tags</Heading>
        </div>
      </div>
      <AssetTagList />
    </div>
  );
}
